export const PAGES_MENUS = [{
  id: 1,
  title: 'Dashboard',
  child: [{
    id: 1,
    title: 'Analytics',
    href: '/dashboard'
  }, {
    id: 2,
    title: 'Finance',
    href: '/dashboard/finance'
  }, {
    id: 3,
    title: 'Ecommerce',
    href: '/dashboard/ecommerce'
  }, {
    id: 4,
    title: 'Crm',
    href: '/dashboard/crm'
  }, {
    id: 5,
    title: 'Marketing',
    href: '/dashboard/logistics'
  }, {
    id: 6,
    title: 'Logistics',
    href: '/dashboard/marketing'
  }, {
    id: 7,
    title: 'Sales',
    href: '/dashboard/sales'
  }, {
    id: 8,
    title: 'LMS',
    href: '/dashboard/learning-management'
  }]
}, {
  id: 2,
  title: 'Pages',
  child: [{
    id: 1,
    title: 'About Us',
    href: '/about-us'
  }, {
    id: 2,
    title: 'Contact Us',
    href: '/contact-us'
  }, {
    id: 3,
    title: 'FAQs',
    href: '/faqs'
  }, {
    id: 4,
    title: 'Pricing',
    href: '/pricing'
  }, {
    id: 5,
    title: 'Career',
    href: '/career'
  },
  // { id: 6, title: 'Career Details', href: '/career/designer' },
  {
    id: 1,
    title: 'Shop',
    href: '/products'
  }, {
    id: 7,
    title: 'Checkout',
    href: '/checkout'
  }, {
    id: 8,
    title: 'Cart',
    href: '/cart'
  }]
}, {
  id: 3,
  title: 'Session',
  child: [{
    id: 1,
    title: 'Login',
    href: '/login'
  }, {
    id: 2,
    title: 'Register',
    href: '/register'
  }, {
    id: 4,
    title: 'Forget Password',
    href: '/forget-password'
  }, {
    id: 5,
    title: 'Verify OTP Code',
    href: '/verify-code'
  }, {
    id: 3,
    title: 'Not Found',
    href: '/abc'
  }, {
    id: 6,
    title: 'Coming Soon',
    href: '/coming-soon'
  }, {
    id: 7,
    title: 'Maintenance',
    href: '/maintenance'
  }]
}];